import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  ButtonGroup,
  Button,
  CustomInput,
  Row,
  Input,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import { localeOptions } from '../../../../../constants/defaultValues';
import Languages from '../../../../../data/languages';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { reactSelectOptionDiffrentPro } from '../../../../../helpers/Utils';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Switch from 'rc-switch';

export default function MultliLanguages({ botSettings, saveIntegration, isHelpcenter }) {
  const [edit, setEdit] = useState(false);
  const [settings, setSetting] = useState(botSettings);
  const [botLanguages, setBotLanguages] = useState([]);
  const [botLanguagesList, setBotLanguagesListt] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: 'en',
    label: 'English',
  });
  const [defaultUrls, setDefaultUrls] = useState([
    { url: "", languageCode: "" }
  ]);
  const [isAutoDetectLanguage, setIsAutoDetectLanguage] = useState(botSettings.features !== null &&
    botSettings.features.autoLanguageDetection !== undefined ? botSettings.features.autoLanguageDetection : false);
  const [isDefaultLanguageUrl, setIsDefaultLanguageUrl] = useState(botSettings.features !== null &&
    botSettings.features.defaultLanguageUrl !== undefined ? botSettings.features.defaultLanguageUrl : false);

  useEffect(() => {
    const getLanguage = Languages.filter(
      (item) => item.code === botSettings.defaultLanguage
    );

    const filtered = Languages.filter((el) => {
      return botSettings.languages.indexOf(el.code) !== -1;
    });
    setBotLanguages(filtered);

    const languageList = Languages.map((elem) => {
      elem.checked = false;
      filtered.forEach((lang) => {
        if (lang.code === elem.code) {
          elem.checked = true;
        }
      });
      return elem;
    });

    setBotLanguagesListt(languageList);

    if (getLanguage !== undefined) {
      let lan = { value: getLanguage[0].code, label: getLanguage[0].name };
      setSelectedLanguage(lan);
    }

    if (botSettings.features !== undefined && botSettings.features !== null &&
      botSettings.features.languageUrl !== undefined &&
      botSettings.features.languageUrl !== null && botSettings.features.languageUrl.length > 0) {
      let links = [];
      botSettings.features.languageUrl.map((m) =>
        links.push({
          url: m.url,
          languageCode: m.languageCode,
        }));
      setDefaultUrls(links);
    }
  }, [botSettings]);

  const handleChange = (e) => {
    const value = e.target.checked;
    setSetting({
      ...settings,
      [e.target.name]: value,
    });
  };

  const handleSave = () => {
    setEdit(!edit);
    // console.log(settings);
    if (defaultUrls.length > 0) {
      settings.features.languageUrl = defaultUrls;
    }
    saveIntegration({ botSetting: settings });
  };

  const handleChangeSelect = (selectedOptions) => {
    setSelectedLanguage(selectedOptions);
    setSetting({
      ...settings,
      defaultLanguage: selectedOptions.value,
    });
  };

  const handleLanguageChange = (e) => {
    const values = botLanguagesList.map((elem) => {
      if (elem.code === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setBotLanguagesListt(values);
  };

  useEffect(() => {
    const langArr = botLanguagesList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.code);

    //console.log(langArr);

    setSetting({
      ...settings,
      languages: langArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botLanguagesList]);

  const handleChangeURL = (e, index) => {
    const values = [...defaultUrls];
    if (e.target.name === 'url') {
      values[index].url = e.target.value;
    }
    setDefaultUrls(values);
  }
  const handleChangeLanguageCode = (lang, index) => {
    const values = [...defaultUrls];
    values[index].languageCode = lang.value;
    setDefaultUrls(values);
  }
  const AddURL = () => {
    let links = [...defaultUrls];;
    links.push({
      url: '',
      languageCode: '',
    });
    setDefaultUrls(links);
  };

  const RemoveURL = (index) => {
    const values = [...defaultUrls];
    values.splice(index, 1);
    setDefaultUrls(values);
  };

  const handleAutoLanguageDetection = (e) => {
    setIsAutoDetectLanguage(e);
    settings.features.autoLanguageDetection = e;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true ? 'Auto language detection enabled successfully' : 'Auto language detection disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: settings });
  };

  const handleDefaultLanguageUrl = (e) => {
    setIsDefaultLanguageUrl(e);
    settings.features.defaultLanguageUrl = e;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true ? 'Default language url enabled successfully' : 'Default language url disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: settings });
  };
  const Show = () => {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody>
            <div className="text-center">
              <h6>Languages:</h6>
              <Separator className="mb-3" />
              <div className="mb-1">
                <b>Enable:</b>
                {botSettings.multilingual ? ' Yes' : ' No'}
              </div>
              <div className="mb-1">
                <b>Default Language:</b> {selectedLanguage.label}
              </div>
              <div className="mb-1">
                <b>Selected Languages:</b>
                <Row>
                  {botLanguages.map((lang, msgIndex) => {
                    return (
                      <Colxx xxs="4" key={msgIndex}>
                        {' '}
                        <p className="text-left">{lang.name}</p>
                      </Colxx>
                    );
                  })}
                </Row>
              </div>
              {isHelpcenter && (
                <Fragment>
                  <div className='d-flex justify-content-xl-around'>
                    <div className="mb-1 mt-2">
                      <b>Auto Language Detection:</b>
                      {botSettings.features.autoLanguageDetection ? ' Yes' : ' No'}
                    </div>
                    <div className="mb-1 mt-2">
                      <b>Default Language URL:</b>
                      {botSettings.features.defaultLanguageUrl ? ' Yes' : ' No'}
                    </div>
                  </div>
                  <div className="mb-1">
                    <b>Languages URLs:</b>
                    {defaultUrls.length > 0 && defaultUrls.filter(k => k.url !== "").length !== 0 ?
                      <Fragment>
                        <Row>
                          <Colxx xxs="8"><b>URLs</b></Colxx>
                          <Colxx xxs="4"><b>Language Code</b></Colxx>
                        </Row>
                        {defaultUrls.map((lang, i) => {
                          return (
                            <Row className="mt-2" key={i}>
                              <Colxx xxs="8">
                                {' '}
                                <p className="text-left"><a href={`${lang.url}`} rel="noopener noreferrer" target="_blank">{lang.url}</a></p>
                              </Colxx>
                              <Colxx xxs="4">
                                <p>{lang.languageCode}</p>
                              </Colxx>
                            </Row>
                          );
                        })}
                      </Fragment>
                      : <p className='text-center mt-2'>No Urls Available</p>}
                  </div>
                </Fragment>
              )}
              <Button
                size="xs"
                color="success"
                outline
                style={{ marginTop: '20px' }}
                onClick={() => {
                  setEdit(!edit);
                }}
              >
                Edit
              </Button>
            </div>
          </CardBody>
        ) : null}
      </Fragment>
    );
  };

  function Edit() {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody>
            <div className="text-center">
              <h6>Language</h6>
              <Separator className="mb-3" />
              <div className="mb-1">
                <b>Enable</b>
                <br />
                <CustomInput
                  id="lan"
                  type="checkbox"
                  checked={settings.multilingual}
                  name="multilingual"
                  onChange={handleChange}
                />
              </div>
              <div className="mb-1">
                <b>Choose Languages</b>
                <br />
                <Row>
                  {botLanguagesList.map((elem, index) => (
                    <Colxx xxs="4" key={index}>
                      {' '}
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.code}
                        id={elem.code}
                        onChange={handleLanguageChange}
                        checked={elem.checked}
                        className="text-left"
                      >
                        {elem.name}
                      </CustomInput>
                    </Colxx>
                  ))}
                </Row>
              </div>

              <div className="mb-1">
                <b>Default Language</b>
                <br />
                <Select
                  isMulti={false}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="defaultLanguage"
                  value={selectedLanguage}
                  placeholder="Select Default Language"
                  onChange={handleChangeSelect}
                  options={
                    Languages
                      ? reactSelectOptionDiffrentPro(
                        botLanguages,
                        true,
                        'code',
                        'name',
                        ''
                      )
                      : []
                  }
                />
              </div>

              <div className="row mt-3 ml-2 mb-1">
                <div className="d-flex w-100">
                  <h5 style={{ marginTop: '0.15rem' }}>Auto language detection</h5>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={isAutoDetectLanguage}
                    name='enabled'
                    onChange={(e) => handleAutoLanguageDetection(e)}
                  />
                </div>
                <div className="row text-left" style={{ marginLeft: '0', marginRight: '1rem' }}>
                  {isAutoDetectLanguage === false ?
                    <p className="m-1 pr-4">When enabled, the language will be auto detected based on the first two messages guest sends. Rest of the conversation will be in that language.</p>
                    :
                    <ul className='pl-2 pr-5'>
                      <li>the AI Chatbot will attempt to detect the language based on the customer message and respond in the same language.</li>
                      <li>the first 5 customer messages are detected, and the responses after that are set to the language of the 5th message.</li>
                      <li>if the customer message is not in one of the enabled languages, AI Chatbot will respond with “Sorry, I do not support this language”. The message is sent in the same language as the user message.</li>
                    </ul>
                  }
                </div>
              </div>
              {isHelpcenter === true &&
                <Fragment>
                  <div className='row mt-3 ml-2 mb-1'>
                    <div className="d-flex w-100">
                      <h5 style={{ marginTop: '0.15rem' }}>Default language by URL</h5>
                      <Switch
                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                        checked={isDefaultLanguageUrl}
                        name='enabled'
                        onChange={(e) => handleDefaultLanguageUrl(e)}
                      />
                    </div>
                  </div>
                  {defaultUrls.length > 0 &&
                    defaultUrls.map((elem, index) => (
                      <Row className="mt-2" key={index}>
                        <Colxx md={"6"}>
                          <Input
                            type="textarea"
                            value={elem.url}
                            onChange={(e) => handleChangeURL(e, index)}
                            name="url"
                            placeholder="URL"
                            style={{ height: "40px" }}
                          ></Input>
                        </Colxx>
                        <Colxx md={"4"}>
                          <Select
                            isMulti={false}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="languageCode"
                            value={Languages.filter(l => l.code === elem.languageCode).map(x => ({ label: x.name, value: x.code }))}
                            placeholder="Select Language"
                            onChange={(e) => handleChangeLanguageCode(e, index)}
                            options={
                              Languages
                                ? reactSelectOptionDiffrentPro(
                                  Languages,
                                  true,
                                  'code',
                                  'name',
                                  ''
                                )
                                : []
                            }
                          />
                        </Colxx>
                        <Colxx md={"2"}>
                          <Button color="danger" size="xs" outline onClick={() => RemoveURL(index)}>-</Button>
                        </Colxx>
                      </Row>
                    ))}
                  <div className='row mt-3 ml-2 mb-1'>
                    <Button color="success" size="xs" outline onClick={AddURL}>+Add</Button>
                  </div>
                </Fragment>
              }
              <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                <Button color="primary" size="xs" outline onClick={handleSave}>
                  Save
                </Button>
                <Button
                  size="xs"
                  color="dark"
                  outline
                  onClick={() => {
                    setEdit(!edit);
                  }}
                >
                  Cancel
                </Button>
              </ButtonGroup>
            </div>
          </CardBody>
        ) : null}
      </Fragment>
    );
  }

  return <Card className="mb-4">{edit ? Edit() : Show()}</Card>;
}
